exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1g8zj{font-family:Open Sans,sans-serif;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-top:20px}._1JmD6{font-weight:700;font-size:16px;line-height:22px;margin:10px 0}._1JmD6,._3faTS{text-align:center}._3faTS{font-weight:400;font-size:14px;line-height:140%}", ""]);

// exports
exports.locals = {
	"containerCenter": "_1g8zj",
	"containerResultTitle": "_1JmD6",
	"containerResultText": "_3faTS"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/SuggestForDefaultAd/SuggestionResultForm/SuggestionResultForm.css
// module id = 2251
// module chunks = 1 17 20